import { ApiCall } from '@api';
import { PROCESSING_ITEMS } from '@constants';
import * as actions from '@store/actions';
import { ui } from '@layouts';
import { useTranslations } from '@libs/translations';

export const openProject = (file, title) => async (dispatch, getState) => {
  const { settings: { locale }} = getState();
  const translations = useTranslations();

  dispatch(actions.startLoading(PROCESSING_ITEMS.OPEN_PROJECT));

  try {
    const response = await ApiCall.getCreatedProject({ locale, file, title });
    const { data } = response;
    const { success, errorText } = data;
    const { data: { id }} = data;

    if (!success) {
      throw new Error(errorText);
    }

    window.open(`/${locale}/projects/${id}/`);
  } catch (error) {
    console.error(error);

    ui.showErrorNotification(translations.t('site.galleryProject.error.tariff'));
  } finally {
    dispatch(actions.endLoading(PROCESSING_ITEMS.OPEN_PROJECT));
  }
};
